// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PkS-","colMin":"styles_colMin__15Bv6"};